/*
 * @Author: changcheng
 * @LastEditTime: 2024-04-12 20:35:30
 */
import { useEffect, useRef, useState } from "react";
import {
  UserOutlined,
  EyeInvisibleOutlined,
  SafetyCertificateOutlined,
  DoubleRightOutlined,
} from "@ant-design/icons";
import { Modal, Button, Form, Input, message } from "antd";
import {
  sndSmsCode,
  validatePhoneNumber,
  checkSmsCode,
  getUserInfoByPhoneNum,
  queryRegisterOrNot,
} from "@root/common/service";
import { registerTextFromWhere } from "@root/common/data/dic";
import { useDispatch, useSelector } from "react-redux";
import { setUserInfo } from "@root/reducers/user";
import { setDictionaries } from "@root/reducers/dictionaries";
import { RootState } from "@root/store";
import signUp_meetingDate from "@root/img/signUp_meetingDate.png";
import meetingDate from "@root/img/meetingDate.png";
const { Search } = Input;
interface LoginPropsType {
  showConfirm: Boolean;
  setShowConfirm: <T extends boolean>(type: T) => void;
  setShowConfirmUserInfo: <T extends boolean>(type: T) => void;
}
export default function ShowConfirm<T extends LoginPropsType>(props: T) {
  const { showConfirm, setShowConfirm, setShowConfirmUserInfo } = props;
  const registerType = useSelector((state: RootState) => state.registerType);
  const dispatch = useDispatch();
  const [liked, setLinked] = useState<boolean>(false);
  const formRef = useRef<any>();
  const [time, setTime] = useState(60);
  /**
   * 获取短信验证码
   * @returns
   */
  const querySmsCode = async () => {
    if (liked) {
      return;
    }
    const { phonenumber } = formRef.current!.getFieldsValue(true);
    if (registerType === "banner") {
      const { data } = await queryRegisterOrNot(phonenumber);
      // 是否已报名
      if (data) {
        message.info("用户已报名");
        return;
      }
    }
    const validatePhoneNumber = await checkUserPhoneNumber();
    // 用户手机存在，并且是注册，直接return
    if (validatePhoneNumber && registerType === "register") {
      message.info("用户信息已注册，请直接登录，初始密码为手机号后6位");
      setShowConfirm(false);
      return;
    }
    if (!phonenumber) {
      message.info("请填写手机号");
      return;
    }
    const { msg, code } = await sndSmsCode(phonenumber);
    if (code === 200) {
      countDown();
      message.success(msg);
    }
  };
  //倒计时
  const countDown = () => {
    if (liked) {
      return;
    }
    setLinked(true);
    // 倒计时
    const active = setInterval(() => {
      //获取接口
      setTime((preSecond) => {
        if (preSecond <= 1) {
          setLinked(false);
          clearInterval(active);
          return 60;
        }

        return preSecond - 1;
      });
    }, 1000);
  };
  /**
   * 查看用户手机号是否存在
   */
  const checkUserPhoneNumber = async () => {
    const { phonenumber } = formRef.current!.getFieldsValue(true);
    const { data } = await validatePhoneNumber(phonenumber);
    return data;
  };
  /**
   * 登录
   * @param values
   */
  const onFinish = async (values: any) => {
    const { phonenumber, smsCode } = values;
    const registerUserStatus = await queryRegisterOrNot(phonenumber);
    // 是否已报名
    if (registerUserStatus.data) {
      message.info("您已报名");
      return;
    }
    const { data } = await checkSmsCode(phonenumber, smsCode);
    if (!data) {
      message.info("验证码错误或已失效,请重新发送");
      return;
    }
    setShowConfirm(false);
    dispatch(
      setUserInfo({
        userName: phonenumber,
      })
    );
    // 跳转注册页面
    setShowConfirmUserInfo(true);
  };
  /**
   * 展示会议日程图片
   */
  const showMeetingImg = () => {
    Modal.warning({
      title: "会议日程",
      width: "800px",
      content: (
        <p>
          <img
            src={signUp_meetingDate}
            alt=""
            style={{
              width: "100%",
            }}
          />
        </p>
      ),
    });
  };
  return (
    <div>
      <Modal
        title={`${registerTextFromWhere.get(registerType)}`}
        visible={showConfirm as any}
        footer={null}
        onCancel={() => {
          setShowConfirm(false);
        }}
        destroyOnClose={true}
      >
        <Form
          name="basic"
          initialValues={{ remember: true }}
          onFinish={onFinish}
          autoComplete="off"
          style={{
            width: "360px",
            margin: "0 auto",
          }}
          ref={formRef}
        >
          {/* {registerType === "banner" && (
            <p
              className="viewMeetingDate"
              onClick={() => {
                showMeetingImg();
              }}
            >
              查看会议日程
            </p>
          )} */}
          <Form.Item
            name="phonenumber"
            rules={[{ required: true, message: "请输入11位手机号" }]}
          >
            <Input
              size="large"
              addonBefore={<UserOutlined />}
              placeholder="请输入11位手机号"
            />
          </Form.Item>
          <Form.Item
            name="smsCode"
            rules={[{ required: true, message: "请输入短信验证码" }]}
          >
            <Search
              placeholder="请输入短信验证码"
              allowClear
              style={{
                padding: 0,
              }}
              enterButton={
                <Button type="primary" onClick={querySmsCode}>
                  &emsp;{liked ? `${time}秒后重发` : " 获取验证码"}&emsp;
                </Button>
              }
              size="large"
              addonBefore={<SafetyCertificateOutlined />}
            />
          </Form.Item>
          <Form.Item
            style={{
              textAlign: "center",
            }}
          >
            <Button type="primary" htmlType="submit">
              确定
            </Button>
          </Form.Item>
        </Form>
        {/* <p className="warningText">
          <span
            onClick={() => {
              message.info("会议暂未开始，敬请期待。");
            }}
          >
            <a>
              会议直播入口
              <DoubleRightOutlined
                style={{
                  color: "#1890ff",
                }}
              />
            </a>
            &nbsp;
          </span>
        </p> */}
        {registerType === "banner" && (
          <img
            src={meetingDate}
            alt=""
            style={{
              width: "100%",
            }}
          />
        )}
        {/* {registerType === "banner" && (
          <p className="warningText">
            <a
              href="https://mvw-testing.oss-cn-beijing.aliyuncs.com/news/template/2023/08/18/20230818_092748_关于开展县域医院综合能力提升项目医学专科交流会（江苏站）的通知.pdf"
              download="关于开展县域医院综合能力提升项目医学专科交流会（江苏站）的通知.pdf"
            >
              点击下载（查看）会议通知原件
            </a>
          </p>
        )}
        {registerType === "banner" && (
          <p className="warningText warning">
            特别提示：因场地原因，通知原件中会议地点变更为南京市金陵饭店亚太楼二层昆仑厅
          </p>
        )} */}
      </Modal>
    </div>
  );
}
